import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import ShowDateAndChanges from './ShowDateAndChanges';
import Approved from './Approved';
import PendingCustomerApproval from './PendingCustomerApproval';
import Rejected from './Rejected';
import CustomerApproved from './CustomerApproved';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { requestResponse } from '../Requests';
import {
  finishWithRequest,
  approveRequestChange,
  rejectPaymentChangeRequest,
} from '../../../API';
import { useLinesContext } from '../../../../contexts/Lines';
import CustomerRejected from './CustomerRejected';

const useStyles = makeStyles((theme: any) => ({
  closeButton: {
    position: 'absolute',
    left: 0,
  },
  dialogBody: {
    '& .MuiDialogContent-root': {
      minHeight: '400px',
      minWidth: '500px',
    },
  },
  dialogBodyLastStep: {
    '& .MuiDialogContent-root': {
      minHeight: '200px',
      minWidth: '500px',
    },
  },
}));

export default function LineChangeDialog({
  request,
  requestsList,
  setRequests,
  open,
  onClose,
}) {
  const classes = useStyles();
  const [currentStep, setCurrentStep] = useState(requestResponse.review);
  const [loading, setLoading] = useState(false);
  const { setLines } = useLinesContext();

  const onCloseDialog = () => {
    onClose();
    setCurrentStep(requestResponse.review);
  };

  const FinishRequest = async () => {
    await finishWithRequest(request.id);
    setLines(null);
    setRequests(requestsList.filter((r, i) => r.id !== request.id));
  };

  const showResponse = async (nextPage: requestResponse) => {
    setLoading(true);
    if (nextPage === requestResponse.customerApproved) {
      setLines(null);
      await approveRequestChange(request.id);
    } else if (nextPage === requestResponse.customerPaymentChangeRejected) {
      await rejectPaymentChangeRequest(request.id);
    } else if (nextPage === requestResponse.approved) {
      onCloseDialog();
      await FinishRequest();
    } else if (nextPage === requestResponse.complete) {
      await FinishRequest();
      onCloseDialog();
    }
    setLoading(false);
    if (
      nextPage !== requestResponse.complete &&
      nextPage !== requestResponse.approved
    )
      setCurrentStep(nextPage);
  };

  return (
    <>
      <Dialog open={open} fullWidth={true} className={classes.dialogBody}>
        {currentStep !== requestResponse.customerApproved && (
          <IconButton onClick={onCloseDialog} className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
        )}
        {currentStep === requestResponse.review && (
          <ShowDateAndChanges request={request} showResponse={showResponse} />
        )}
        {currentStep === requestResponse.approvedChangesNoRecalc && (
          <Approved
            request={request}
            showResponse={showResponse}
            loading={loading}
          />
        )}
        {currentStep === requestResponse.pendingCustomerApproval && (
          <PendingCustomerApproval
            request={request}
            showResponse={showResponse}
            loading={loading}
          />
        )}
        {currentStep === requestResponse.customerApproved && (
          <CustomerApproved showResponse={showResponse} loading={loading} />
        )}
        {currentStep === requestResponse.customerPaymentChangeRejected && (
          <CustomerRejected showResponse={showResponse} loading={loading} />
        )}
        {currentStep === requestResponse.rejected && (
          <Rejected
            request={request}
            showResponse={showResponse}
            loading={loading}
          />
        )}
      </Dialog>
    </>
  );
}
